import template from './access_denied.html';

class AccessDeniedVM
{
	constructor(page)
	{
		this.page = page;
	}
}

class AccessDeniedPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AccessDeniedVM(this);
	}

	init()
	{
		document.title = tr('Access Denied');
	}

	updateData() { }

	tearDown() { }
}

export default {
	route: '[/]access_denied',
	page_class: AccessDeniedPage,
	template: template,
	template_filename: 'translation/access_denied'
};
